<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="pdf == null" class="text-center">
      <b-spinner variant="primary" v-if="loader"></b-spinner>
    </div>
    <iframe v-else :src="pdf" style="width: 100%; height: 800px"></iframe>
  </div>

</template>

<script>
export default {
  name: "VerCertificado",
  props: {
    certificado: Object,
    plataforma: String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    pdf: null,
    loader: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    if(this.plataforma === 'Stripe'){
      this.getCertificadoStripe();
    }else{
      this.getCertificado();
    }
  },
  methods: {
    getCertificado() {
      this.loader = true;
      let datos = {
        emailToken:  this.certificado.emailToken
      }
      this.$http.post(this.$api + 'certificado/token', datos).then((certificado) => {
        const pdf = certificado.data.data;
        this.pdf = 'data:application/pdf;base64,' + pdf;
        this.loader = false;
      }).catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Ocurrio un error",
              text: error.message,
            });
        this.loader = false;
          });
    },
    getCertificadoStripe() {
      this.loader = true;
      let datos = {
        idCertificado: this.certificado.idCertificado
      }
      this.$http.post(this.$api + 'certificado/stripe/idCertificado', datos).then((certificado) => {
        const pdf = certificado.data.data;
        this.pdf = 'data:application/pdf;base64,' + pdf;
        this.loader = false;
      }).catch((error) => {
        this.$swal.fire({
          icon: "error",
          title: "Ocurrio un error",
          text: error.message,
        });
        this.loader = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
